import React, {useState} from "react";
import {TestDoneView} from "../views/testDoneView.js";
import {userModel} from "../index.js";
function TestDone(props) {
    const [gender, setGender] = useState("");
    const [age, setAge] = useState("");
    const [GDPR, setGDPR] = useState("");
    const [occupation, setOccupation] = useState("");
    const [kthMail, setMail] = useState("");
    return React.createElement(TestDoneView, {
        onGender: (gender) => setGender(gender),
        onAge: (age) => setAge(age),
        onOccupation: (occ) => setOccupation(occ),
        onGDPR: (yes) => setGDPR(yes),
        onKthMail: (mail) => setMail(mail),
        onSubmit: () => SetInfo(gender, age, GDPR, occupation, kthMail) // ändra till att den sätts i modellen sen
        });
}

function SetInfo(gender, age, GDPR, occ, mail) {
    userModel.setGender(gender);
    userModel.setAge(age);
    userModel.setGDPR(GDPR);
    userModel.setOccupation(occ);
    userModel.setMail(mail);
    userModel.uploadFB();
}
export default TestDone;